import React from 'react';

const ParentCardNoHeader = ({ children, title }) => {
  return (
    <div className="card">
      <div className="card-content">
        <h5 className="card-title">{title}</h5>
        {children}
      </div>
    </div>
  );
};

export default ParentCardNoHeader;
